import { PRODUCT_TYPES } from 'productTemplate/enums/productType';

export const findParentProductCategory = (childKey: string): string => {
  for (const parentKey of Object.keys(PRODUCT_TYPES)) {
    if (PRODUCT_TYPES[parentKey].has(childKey)) {
      return parentKey === 'all' ? childKey : parentKey;
    }
  }
  return null;
};
